// extracted by mini-css-extract-plugin
export default {"key-id":"_1V98IAa2ZC","keyId":"_1V98IAa2ZC","right-tag":"KOH+uC-Uv1","rightTag":"KOH+uC-Uv1"};